import { FileManagementFile } from "../../Interfaces/fileManagementFile";

export const createFileManagementFieldModel = (
  files: FileManagementFile[],
  existingFiles: FileManagementFile[]
) => {
  return {
    files: [...existingFiles, ...files]
  };
};
